<template>
  <div class="filter-container">
    <label class="filter-title">
      <b>ค้นหา Label</b>
    </label>
    <div class="filter input-text">
      <input
v-model="search.text" :disabled="disabled" type="text" class="el-input__inner"
        placeholder="ค้นหา Label" @keyup.enter="$emit('search')" />
      <el-button :disabled="disabled" type="sc-asset" icon="el-icon-search" @click="$emit('search')">
        ค้นหา
      </el-button>
    </div>
  </div>
</template>

<script lang="js">

export default {
  props: {
    filter: {
      type: Object,
      required: true,
      validator: (filter) => filter && typeof filter.text === 'string'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      search: {
        text: this.filter.text || ''
      }
    }
  },
  watch: {
    search: {
      handler(newSearch) {
        this.$emit('change', newSearch)
      },
      deep: true
    },
    filter: {
      handler(newFilter) {
        if (newFilter.text !== this.search.text) {
          this.search.text = newFilter.text || ''
        }
      },
      deep: true,
      immediate: true
    }
  }
}

</script>

<style scoped>
.filter-container {
  background: transparent;
  border-radius: 18px;
  padding: 0;
}

.filter-title {
  display: block;
  font-size: 1rem;
  margin-bottom: var(--size-sm);
  color: #111827;
}

.filter.input-text {
  display: flex;
  gap: var(--size-md);
  align-items: center;
}

.filter.input-text .el-input__inner {
  height: 40px;
  border-radius: 4px;
  border: 1px solid #e5e7eb;
  background: transparent;
  font-size: 14px;
  padding: 0 14px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.filter.input-text .el-input__inner:focus {
  border-color: #cbd5e1;
  box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.15);
}

.filter.input-text .el-button {
  background: transparent;
  border: 1px solid #d1d5db;
  color: #6b7280;
  height: 40px;
  border-radius: 4px;
  padding: 0 18px;
  font-weight: 600;
  transition: all 0.2s ease;
}

.filter.input-text .el-button:hover {
  background: rgba(107, 114, 128, 0.08);
  border-color: #cbd5e1;
  color: #4b5563;
}

/* Disabled state */
.filter.input-text .el-input__inner:disabled {
  background-color: #f5f5f5;
  border-color: #e0e0e0;
  color: #999;
  cursor: not-allowed;
}

.filter.input-text .el-button:disabled {
  background-color: #f5f5f5;
  border-color: #e0e0e0;
  color: #999;
  cursor: not-allowed;
}

.filter.input-text .el-button:disabled:hover {
  background: #f5f5f5;
  border-color: #e0e0e0;
  color: #999;
}

/* Responsive */
@media screen and (max-width: 768px) {
  .filter.input-text {
    flex-direction: column;
    align-items: stretch;
  }

  .filter.input-text .el-button {
    width: 100%;
    justify-content: center;
  }
}
</style>
